ko.components.register('domain-field', {
	viewModel: function(params) {
		var self = this;

		self.element = false;
		self.tip = false;
		self.showDetails = ko.observable(false);

		self.id = ko.observable(params.id);
		self.name = ko.observable(params.name);

		// data

		self.type = ko.observable();
		self.field = ko.observable();
		self.value = ko.observable();
		self.label = ko.observable();

		self.class = ko.observable();

		self.fieldValue = ko.observable();

		// ajax

		self.loading = ko.observable(false);

		self.ajaxRequest = function(action, params, callback) {
			if(self.loading())
				return;
			self.loading(true);
			return App.ajaxRequest('domain/' + action, params).done(function(r) {
				callback && callback(r);
			}).always(function() {
				self.loading(false);
			});
		};

		self.update = function() {
			if(self.showDetails())
				self.toggleDetails();

			var params = {
				id: self.id(),
				data: {}
			};

			params.data[self.field()] = self.fieldValue() || 0;

			// send update request
			return self.ajaxRequest('update', params, function(r) {
				if(!r)
					return;
				if(r.errors)
					alert(r.errors.join("\n"));
				if(r.ok) {
					self.value(self.fieldValue());
					self.label(r[self.field()] || self.value());
					$('#domain-field-' + self.getUID()).html(self.label());
				}
			});
		};

		self.setData = function(data) {
			self.type((data && data.type));
			self.field((data && data.field));
			self.value((data && data.value));
			self.label((data && data.label) || self.value());
			self.class((data && data.class));
		};

		// methods

		self.getUID = ko.pureComputed(function() {
			return self.field() + '-' + self.id();
		});

		self.getLabel = ko.pureComputed(function() {
			return self.value() || '&nbsp;';
		});

		self.getTitle = ko.pureComputed(function() {
			const v = self.field();
			return v.replace('has_', '').replaceAll('_', ' ');
		});

		self.getType = ko.pureComputed(function() {
			return self.type() || 'text';
		});

		self.getClass = ko.pureComputed(function() {
			return self.class() || false;
		});

		self.toggleDetails = function(data, event) {
			self.showDetails(!self.showDetails());

			if(!self.showDetails()) {
				self.tip
					.stop()
					.animate({left: '15px', opacity: 0}, 200, function() {
						self.element.removeClass('active');
						self.element.popover('hide');
						self.tip.css({left: -1000});
					});
			} else {
				var $details = $('#domain-field-details-' + self.field() + '-' + self.id());

				self.fieldValue(self.value());

				if(!self.element)
					self.element = $(event.target);
				if(!self.element.data('bs.popover')) {
					self.element.popover({
						animation: false,
						placement: 'right',
						html: true,
						content: $details
					});
					$details.show();
					self.tip = $(self.element.data('bs.popover').getTipElement());
				}

				self.element.addClass('active');
				self.element.popover('show');

				$details.find('input').focus();

				self.tip
					.stop()
					.css({left: '15px', opacity: 0})
					.animate({left: 0, opacity: 1}, 200);
			}
		};

		self.setData(params.data || {});
	},
	template: "<div class=\"cursor-pointer domain-field d-block\" data-bind=\"\n\tattr: { 'id': 'domain-field-' + getUID()},\n\thtml: label,\n\tevent: { click: toggleDetails }\"></div>\n<div style=\"display:none;min-width:200px\" data-bind=\"attr: { 'id': 'domain-field-details-' + getUID()}\">\n\t<div class=\"domain-field-details\" data-bind=\"css: { 'loading': loading() }\">\n\t\t<small class=\"spinner spinner-border spinner-primary\" data-bind=\"visible: loading()\"></small>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col mb-2\">\n\t\t\t\t<h5 class=\"domain-field-header\">\n\t\t\t\t\t<span data-bind=\"text: name()\"></span>\n\t\t\t\t\t<small class=\"text-muted\" data-bind=\"text: getTitle\"></small>\n\t\t\t\t</h5>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"domain-field-body\">\n\t\t\t<input data-bind=\"attr: {'type': getType(), 'class': 'form-control ' + getClass()}, value: fieldValue\"/>\n\n\t\t\t<div class=\"buttons mt-2\">\n\t\t\t\t<button class=\"btn btn-primary\" data-bind=\"click: update\">Update</button>\n\t\t\t\t<button class=\"btn btn-secondary\" data-bind=\"attr: {'data-parent': '#domain-field-' + getUID()}, click: toggleDetails\">Cancel</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"
});